// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"2e90b03f","628":"828c7c5a"}[chunkId] + ".chunk.js";
};